import { Route, Routes } from 'react-router';
import './App.css';
import DashboardLayout from './components/DashboardLayout';
import DetalleAprendiz from './components/DetalleAprendiz';
import Actividad from './view/Actividad';
import AsociarEnteVsRector from './view/AsociarEnteVsJefe';
import Centro from './view/Centros';

import AsignacionModulos from './view/AsignacionModulos';
import Grupos from './view/Grupos';
import Home from './view/Home';
import Jefes from './view/Jefes';
import ListarActas from './view/ListarActas';
import ListarAprendices from './view/ListarAprendices';
import ListarContratos from './view/ListarContratos';
import ListarEnte from './view/ListarEnteconformador';
import ListarEProductiva from './view/ListarEProductiva';
import ListarGuias from './view/ListarGuiasdeAprendizaje';
import ListarInformesContractuales from './view/ListarInformesContractuales';
import ListarInstructores from './view/ListarInstructores';
import ListarMatriculados from './view/ListarMatriculados';
import ListarMatriculas from './view/ListarMatriculas';
import ListarResoluciones from './view/ListarResoluciones';
import ListarTarjetaAprendiz from './view/ListarTarjetasAsignadas';
import Notificaciones from './view/Notificaciones';
import Obligaciones from './view/ObligacionesContractuales';
import Programas from './view/Programas';
import Regional from './view/Regional';
import RegistrarGuia from './view/RegisrtarGuiasdeAprendizaje';
import RegistarTestKolb from './view/RegistarTestKolb';
import RegistrarActas from './view/RegistrarActas';
import AgendasViaticos from './view/RegistrarAgendasViatiocos';
import ResgistrarAprendices from './view/RegistrarAprendices';
import Asistencia from './view/RegistrarAsistencia';
import RegistrarBitacoras from './view/RegistrarBitacoras';
import RegistrarContratos from './view/RegistrarContratos';
import RegistrarEnte from './view/RegistrarEnteConformador';
import RegistrarEProductiva from './view/RegistrarEProductiva';
import RegistrarFirmaAcudiente from './view/RegistrarFirmaAcudiente';
import RegistrarFirmaAprendiz from './view/RegistrarFirmaAprendiz';
import RegistrarFirmaInstructor from './view/RegistrarFirmaInstructor';
import RegistrarInformeContractual from './view/RegistrarInformeContractual';
import RegisatrarInstructores from './view/RegistrarInstructores';
import RegistrarMatriculas from './view/RegistrarMatriculas';
import RegistrarResoluciones from './view/RegistrarResoluciones';
import RegistrarSegPractica from './view/RegistrarSegPractica';
import RegistrarTarjetaAprendiz from './view/RegistrarTarjetaAprendiz';


function App() {
  return (
    <div className="App">
      <DashboardLayout>
        <Routes>

          <Route path="/" element={<Home />} />
          <Route path="/instructor/listarinstructores" element={<ListarInstructores />} />
          <Route path="/instructor/registrarinstructores" element={<RegisatrarInstructores />} />
          <Route path="/instructor/registrarinstructores/:id" element={<RegisatrarInstructores />} />

          <Route path="/instructor/registrarcontratos/:id" element={<RegistrarContratos />} />
          <Route path="/instructor/registrarcontratos/editar/:idcontrato" element={<RegistrarContratos />} />
          <Route path="/instructor/listarcontratos/:id" element={<ListarContratos />} />
          <Route path="/instructor/obligaciones/:id" element={<Obligaciones />} />

          <Route path="/instructor/informecontractual/:id" element={<RegistrarInformeContractual />} />
          <Route path="/instructor/informecontractual/editar/:informeId" element={<RegistrarInformeContractual />} />
          <Route path="/instructor/informecontractual/listar/:id" element={<ListarInformesContractuales />} />
          <Route path="/instructor/agendasviaticos" element={<AgendasViaticos />} />
          <Route path="/instructor/registrarfirma/:id" element={<RegistrarFirmaInstructor />} />

          <Route path="/aprendiz/listaraprendices" element={<ListarAprendices />} />
          <Route path="/aprendiz/registraraprendices" element={<ResgistrarAprendices />} />
          <Route path="/aprendiz/:id" element={<DetalleAprendiz />} />
          <Route path="/aprendiz/registraraprendices/:id" element={<ResgistrarAprendices />} />
          <Route path="/aprendiz/testkolb/registrar/:id" element={<RegistarTestKolb />} />
          <Route path="/aprendiz/testkolb/editar/:testid" element={<RegistarTestKolb />} />
          <Route path="/aprendiz/registrarfirma/:id" element={<RegistrarFirmaAprendiz />} />
          <Route path="/aprendiz/registrarfirma/:idAprendiz/:idAcudiente" element={<RegistrarFirmaAcudiente />} />

          <Route path="/institucional/regional" element={<Regional />} />
          <Route path="/institucional/regional/:id" element={<Regional />} />
          <Route path="/institucional/centro" element={<Centro />} />
          <Route path="/institucional/centro/:id" element={<Centro />} />
          <Route path="/institucional/programas" element={<Programas />} />
          <Route path="/institucional/programas/:id" element={<Programas />} />
          <Route path="/institucional/programas/guias/registrar/:programaId/:codPrograma" element={<RegistrarGuia />} />
          <Route path="/institucional/programas/guias/editar/:guiaId" element={<RegistrarGuia />} />
          <Route path="/institucional/programas/guias/listarguias/:codPrograma" element={<ListarGuias />} />
          <Route path="/institucional/grupos" element={<Grupos />} />
          <Route path="/institucional/grupos/:id" element={<Grupos />} />
          <Route path="/institucional/grupos/actas/registrar/:grupoId/:fichaGrupo" element={<RegistrarActas />} />
          <Route path="/institucional/grupos/actas/editar/:actaId" element={<RegistrarActas />} />
          <Route path="/institucional/grupos/actas/listaractas/:id" element={<ListarActas />} />

          <Route path="/enteconformador/registrar" element={<RegistrarEnte />} />
          <Route path="/enteconformador/editar/:id" element={<RegistrarEnte />} />
          <Route path="/enteconformador/listar" element={<ListarEnte />} />
          <Route path="/enteconformador/resoluciones/registrar/:idEnte" element={<RegistrarResoluciones />} />
          <Route path="/enteconformador/resoluciones/editar/:idResolucion" element={<RegistrarResoluciones />} />
          <Route path="/enteconformador/resoluciones/:id" element={<ListarResoluciones />} />
          <Route path="/enteconformador/jefes" element={<Jefes />} />
          <Route path="/enteconformador/jefes/:id" element={<Jefes />} />
          <Route path="/enteconformador/asociar/jefeinmediato/:id" element={<AsociarEnteVsRector />} />
          <Route path="/enteconformador/asociar/jefeinmediato/editar/:idasociado" element={<AsociarEnteVsRector />} />

          <Route path="/matricula/listarmatriculas" element={<ListarMatriculas />} />
          <Route path="/matricula/registrar" element={<RegistrarMatriculas />} />
          <Route path="/matricula/editar/:id" element={<RegistrarMatriculas />} />

          <Route path="/matricula/listarmatriculados/:id" element={<ListarMatriculados />} />
          <Route path="/actividad/registrar/:id" element={<Actividad />} />
          <Route path="/asistencia/actividad/:id" element={<Asistencia />} />
          <Route path="/tarjeta/registrartarjetaaprendiz" element={<RegistrarTarjetaAprendiz />} />
          <Route path="/tarjeta/listartarjetaaprendiz" element={<ListarTarjetaAprendiz />} />

          <Route path="/etapaproductiva/registro/:aprendizId/:matriculaId" element={<RegistrarEProductiva />} />
          <Route path="/etapaproductiva/registromasivo/:matriculaId" element={<RegistrarEProductiva />} />

          <Route path="/etapaproductiva/listareproductiva/" element={<ListarEProductiva />} />
          <Route path="/etapaproductiva/bitacoras/:etapaId/:aprendizId/:matriculaId" element={<RegistrarBitacoras />} />
          <Route path="/etapaproductiva/bitacoras/registromasivo/:matriculaId" element={<RegistrarBitacoras />} />

          
          <Route path="/etapaproductiva/seguimiento/registromasivo/:matriculaId" element={<RegistrarSegPractica />} />
          <Route path="/etapaproductiva/seguimiento/:etapaId/:aprendizId/:matriculaId" element={<RegistrarSegPractica />} />

          <Route path="/configuraciones/asignarmodulos" element={<AsignacionModulos />} />
          <Route path="/configuraciones/notificaciones" element={<Notificaciones />} />




        </Routes>
      </DashboardLayout>
    </div>
  );
}

export default App;
